/**
 * FilterType
 * @enum FilterType - Types of filters that can be applied for the support page
 */
enum FilterType {
  /** Filter by type of ticket */
  Type = 'Type',
  /** Filter by ticket status */
  Status = 'Status',
  /** Filter by requester */
  Requester = 'Requester',
  /** Filter by organization */
  Organization = 'Organization',
  /** Filter by date ticket was created */
  CreatedDate = 'Date Created'
}

export default FilterType;
